import { useState } from 'react';
import PropTypes from 'prop-types';

const CloseButton = ({ closeModal }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      type="button"
      className="ml-auto cursor-pointer duration-150 hover:scale-105"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label="Close"
      onClick={closeModal}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.68382 0.441786L9 6.7577L15.2835 0.474511C15.4222 0.326787 15.5894 0.208613 15.775 0.127075C15.9606 0.0455364 16.1607 0.00231422 16.3634 0C16.7974 0 17.2136 0.17239 17.5205 0.479245C17.8273 0.786101 17.9997 1.20229 17.9997 1.63625C18.0035 1.83685 17.9663 2.03612 17.8904 2.22183C17.8144 2.40753 17.7013 2.57575 17.5579 2.71617L11.1927 8.99935L17.5579 15.3644C17.8276 15.6282 17.9858 15.9854 17.9997 16.3625C17.9997 16.7964 17.8273 17.2126 17.5205 17.5195C17.2136 17.8263 16.7974 17.9987 16.3634 17.9987C16.1549 18.0074 15.9468 17.9726 15.7524 17.8965C15.5581 17.8204 15.3816 17.7048 15.2344 17.5569L9 11.241L2.70019 17.5406C2.56193 17.6834 2.39676 17.7974 2.2142 17.876C2.03165 17.9546 1.83534 17.9963 1.63658 17.9987C1.2026 17.9987 0.7864 17.8263 0.479532 17.5195C0.172663 17.2126 0.000266239 16.7964 0.000266239 16.3625C-0.00354882 16.1619 0.0336723 15.9626 0.109646 15.7769C0.185619 15.5912 0.298742 15.423 0.442071 15.2825L6.80734 8.99935L0.442071 2.63436C0.172382 2.37053 0.0142397 2.01326 0.000266239 1.63625C0.000266239 1.20229 0.172663 0.786101 0.479532 0.479245C0.7864 0.17239 1.2026 0 1.63658 0C2.0293 0.00490874 2.40565 0.163625 2.68382 0.441786Z"
          fill={`${
            isHovered
              ? 'var(--color-pj-primary-400)'
              : 'var(--color-pj-primary-300)'
          }`}
        />
      </svg>
    </button>
  );
};

CloseButton.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default CloseButton;
